(function () {
  // MageWorx Advanced Product Options (APO) owns the buy box on configurable PDPs and
  // emits `mw-`-prefixed markup. (Note: assets/judgeme-aria-fix.js calls these classes
  // "Mantine internals" — that label is wrong. `mw-` is MageWorx; the value ids in
  // data-mw-tooltip, e.g. v_19862809 / o_2314954, are APO option-value ids. See the
  // APO geometry table in memory-bank/apo-architecture.md.)
  //
  // APO's tooltip layer stamps aria-expanded="false" onto EVERY [data-mw-tooltip]
  // trigger and then never updates it — verified on production: the attribute does not
  // flip on hover, pointerdown or click. On /products/hidden-bookcase-door that is 244
  // nodes (mw-option__swatch-media 224, mw-tooltip--icon 14, mw-option__button 6), all
  // of them plain <div>/<span> carrying no role. ARIA does not allow aria-expanded on a
  // roleless generic container, so axe/Lighthouse fail it as `aria-allowed-attr`
  // (weight 10 — the single largest term in the mobile accessibility score).
  //
  // Removal is the correct remediation, not role-invention: adding role="button" to 224
  // swatch <div>s that already sit inside <label class="mw-label"> wrapping the real
  // input would create duplicate interactive semantics and change actual behaviour.
  //
  // 🚨 SAFETY — why this is an ALLOWLIST and not a blanket strip. APO uses aria-expanded
  // LEGITIMATELY in two places, and one of them is STATEFUL:
  //   1. .mw-accordion__header — created as a real <button> (bundle: s.type="button").
  //   2. .mw-accordion__summary-value-title — a truncate/expand toggle whose click
  //      handler READS the attribute back to decide direction:
  //         const Ve = re.getAttribute("aria-expanded") === "true";
  //         re.textContent = Ve ? truncated : full;
  //      Stripping it there would pin the toggle to one direction — a real functional
  //      regression on the buy box.
  // Neither carries data-mw-tooltip, so gating on that attribute excludes both by
  // construction. The guards below additionally preserve anything with an explicit
  // role or a native interactive tag. Measured on production: the selector matched
  // 244/244 flagged nodes with 0 missed and 0 overreach.
  //
  // MAINTENANCE: if APO stops emitting data-mw-tooltip, or starts driving real state
  // through aria-expanded on a tooltip trigger, re-verify before widening this.
  var TRIGGER = '[data-mw-tooltip][aria-expanded]';
  var NATIVE_INTERACTIVE =
    /^(BUTTON|A|SUMMARY|INPUT|SELECT|TEXTAREA|DETAILS|OPTION)$/;

  function isStrippable(el) {
    return !el.getAttribute('role') && !NATIVE_INTERACTIVE.test(el.tagName);
  }

  function stripTooltipAriaExpanded() {
    var els = document.querySelectorAll(TRIGGER);
    for (var i = 0; i < els.length; i++) {
      if (isStrippable(els[i])) {
        els[i].removeAttribute('aria-expanded');
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stripTooltipAriaExpanded);
  } else {
    stripTooltipAriaExpanded();
  }

  // APO re-renders the option tree on every selection change, which re-stamps the
  // attribute — so a one-shot fix would be silently undone the moment a customer picks
  // a wood or a width. The observer therefore stays live rather than disconnecting on a
  // timer the way judgeme-aria-fix.js does (that widget injects once and settles; this
  // one re-renders for the whole session).
  //
  // Cost is bounded: the observer is scoped to the APO form container (not document.body
  // — judgeme-a11y-patches.js already runs two body-wide observers) and the callback is
  // debounced, so a burst of re-render mutations collapses into one pass.
  // .mw-apo-container is APO's own wrapper (verified live). The fallback walks up from a
  // real trigger so a container rename degrades to a narrower scope rather than silently
  // disabling the observer. Deliberately NOT document.body (judgeme-a11y-patches.js
  // already runs two body-wide observers), and deliberately not the product form — that
  // form has an input named "id", so form.id is DOM-clobbered to an HTMLInputElement.
  function findContainer() {
    var trigger = document.querySelector('[data-mw-tooltip]');
    return (
      document.querySelector('.mw-apo-container') ||
      (trigger &&
        trigger.closest('.mw-apo-container, .product__info-wrapper, main')) ||
      null
    );
  }

  var pending = null;
  function scheduleStrip() {
    if (pending) return;
    pending = setTimeout(function () {
      pending = null;
      stripTooltipAriaExpanded();
    }, 200);
  }

  function attachScopedObserver() {
    var container = findContainer();
    if (!container) return false;
    new MutationObserver(scheduleStrip).observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-expanded'],
    });
    return true;
  }

  // This script is loaded `defer`, so it executes BEFORE APO (which injects async) has
  // put .mw-apo-container in the DOM — querying for the container here would find
  // nothing and the scoped observer would never attach at all. So: if the container
  // isn't up yet, run a short-lived bootstrap observer that keeps stripping while it
  // waits, hands off to the scoped observer the moment APO lands, and disconnects.
  if (!attachScopedObserver()) {
    var boot = new MutationObserver(function () {
      scheduleStrip();
      if (attachScopedObserver()) boot.disconnect();
    });
    boot.observe(document.documentElement, { childList: true, subtree: true });
    // Backstop: never leave the document-wide bootstrap observer live. 15s comfortably
    // covers APO's async injection on a slow mobile connection.
    setTimeout(function () {
      boot.disconnect();
    }, 15000);
  }

  // 2s backstop for the case where APO injected before this script ran at all.
  setTimeout(stripTooltipAriaExpanded, 2000);
})();
